import { useOrderByIdQuery } from 'api';
import { useParams } from 'react-router-dom';
import { useCallback, useState } from 'react';

export const useContactPersons = () => {
  const { id } = useParams() as { id: string };
  const { data: orderDetails, isLoading } = useOrderByIdQuery({ id }, { skip: !id });

  const [drawerVisible, setDrawerVisible] = useState(false);
  const [expandedPersons, setExpandedPersons] = useState<Set<string>>(new Set());

  const toggleDrawer = useCallback(() => setDrawerVisible((prev) => !prev), []);

  const toggleExpandPerson = useCallback((personId: string) => {
    setExpandedPersons((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(personId)) {
        newSet.delete(personId);
      } else {
        newSet.add(personId);
      }
      return newSet;
    });
  }, []);

  const isPersonExpanded = useCallback((personId: string) => expandedPersons.has(personId), [expandedPersons]);

  return {
    contactPersons: orderDetails?.contactPersonList,
    drawerVisible,
    toggleDrawer,
    orderDetails,
    toggleExpandPerson,
    isPersonExpanded,
    isLoading,
  };
};
